import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import determinarPaginaAtualPreco from '../../actions/preco/determinarPaginaAtualPreco'
import BotoesPaginacao from '../comum/BotoesPaginacao'

export class BotoesPaginacaoPreco extends Component {
  render () {
    return <BotoesPaginacao
      numeroElementos={this.props.totalRegistros}
      paginaAtual={this.props.paginaAtual}
      registrosPorPagina={this.props.registrosPorPagina}
      determinarPaginaAtual={this.props.determinarPaginaAtualPreco}/>
  }
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualPreco,
    precos: state.precoPaginacao.precos,
    totalRegistros: state.precoPaginacao.totalRegistros,
    registrosPorPagina: state.registrosPorPaginaPreco
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({ determinarPaginaAtualPreco }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(BotoesPaginacaoPreco)
